// extracted by mini-css-extract-plugin
module.exports = {"container":"jg","products":"kg","cta":"lg","disabled":"mg"};